<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style  lang="less" >
//FF5D00
// @theme-color: #0054ec; // sea blue
@theme-color: #FF5D00; // sea blue #FF5D00
#app {
  background: #f5f4f2;
  min-height: 100vh;
}
.van-nav-bar{
   padding-top: constant(safe-area-inset-top);
   padding-top: env(safe-area-inset-top);
}

.margin-bottom-36 {
  margin-bottom: 36px;
}
.margin-bottom-34 {
  margin-bottom: 34px;
}

.z-2023 {
  z-index: 2023 !important;
}

.flex {
  display: flex;
}

.flex-1 {
  flex: 1;
}

.flex-align-center {
  align-items: center;
}

.flex-align-end {
  align-items: flex-end;
}

.flex-align-start {
  align-items: flex-start;
}

.flex-column {
  flex-direction: column;
}

.flex-justify-center {
  justify-content: center;
}

.flex-justify-between {
  justify-content: space-between;
}

.flex-justify-end {
  justify-content: flex-end;
}

.flex-justify-around {
  justify-content: space-around;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-row-reverse {
  flex-direction: row-reverse;
}

.flex-shrink {
  flex-shrink: 0;
}

.font-0 {
  font-size: 0;
}

.font-8 {
  font-size: 8px;
}

.line-height {
  line-height: 8px;
}

.font-9,
.line-height-9 {
  font-size: 9px;
}

.font-10 {
  font-size: 10px;
}

.line-height-10 {
  line-height: 10px;
}

.font-11 {
  font-size: 11px;
}

.line-height-11 {
  line-height: 11px;
}

.font-12 {
  font-size: 12px;
}

.line-height-12 {
  line-height: 12px;
}

.font-13 {
  font-size: 13px;
}

.line-height-13 {
  line-height: 13px;
}

.font-14 {
  font-size: 14px;
}

.line-height-14 {
  line-height: 14px;
}

.font-15 {
  font-size: 15px;
}

.line-height-15 {
  line-height: 15px;
}

.font-16 {
  font-size: 16px;
}

.line-height-16 {
  line-height: 16px;
}

.font-17 {
  font-size: 17px;
}

.line-height-17 {
  line-height: 17px;
}

.font-18 {
  font-size: 18px;
}

.line-height-18 {
  line-height: 18px;
}

.font-20 {
  font-size: 20px;
}

.line-height-19 {
  line-height: 19px;
}

.line-height-20 {
  line-height: 20px;
}

.font-21 {
  font-size: 21px;
}

.line-height-21 {
  line-height: 21px;
}

.font-22 {
  font-size: 22px;
}

.line-height-22 {
  line-height: 22px;
}

.font-24 {
  font-size: 24px;
}

.line-height-23 {
  line-height: 23px;
}
.line-height-24 {
  line-height: 24px;
}

.font-26 {
  font-size: 26px;
}

.line-height-26 {
  line-height: 26px;
}

.font-28 {
  font-size: 28px;
}

.line-height-28 {
  line-height: 28px;
}

.font-29,
.line-height-29 {
  font-size: 29px;
}

.font-30 {
  font-size: 30px;
}

.font-40 {
  font-size: 40px;
}

.font-44 {
  font-size: 44px;
}

.font-50 {
  font-size: 50px;
}

.line-height-30 {
  line-height: 30px;
}

.font-32 {
  font-size: 32px;
}

.line-height-32 {
  line-height: 32px;
}

.font-36 {
  font-size: 36px;
}

.line-height-36 {
  line-height: 36px;
}

.font-48 {
  font-size: 48px;
}

.line-height-48 {
  line-height: 48px;
}

.font-weight-400 {
  font-weight: 400;
}

.font-weight-500 {
  font-weight: 500;
}

.font-weight-bold {
  font-weight: bold;
}

.font-weight-600 {
  font-weight: 600;
}

.font-weight-800 {
  font-weight: 800;
}

.zoom-70 {
  zoom: 0.7;
}

.scale-70 {
  transform: scale(0.7);
}

.scale-80 {
  transform: scale(0.8);
}

.line-height-1 {
  line-height: 1;
}

.white {
  color: #fff;
}

.white-back {
  background-color: #fff;
}

.placeholder {
  color: #d0cbc1;
}

.placeholder-back {
  background-color: #d0cbc1;
}

.F6F6F6-back {
  background-color: #F6F6F6  ;
}

.theme {
  color: @theme-color;
}

.theme-back {
  background-color: @theme-color;
}

.deeptheme {
  color: @theme-color;
}

.deeptheme-back {
  background-color: @theme-color;
}

.secondary {
  color: #9c9891;
}

.secondary-back {
  background-color: #9c9891;
}

.black {
  color: #3d3d3d;
}

.black-back {
  background-color: #3d3d3d;
}

.disabled {
  color: #B8B8B8;
}

.disabled-back {
  background-color: #B8B8B8 !important;
}

.page-back {
  background: #f5f4f2;
}

.theme-border {
  border: 1px solid #FF5D00;
}

.secondary-border {
  border: 1px solid #9c9891;
}

.page-back {
  background-color: #f5f4f2;
}

.sec-border-bottom {
  border-bottom: 1px solid #f5f4f2;
}

.eleme-back {
  background-color: #52b4f7;
}

.meituan-back {
  background-color: #f8d347;
}

.blue {
  color: #008eff;
}

.red {
  color: #FF0000;
}

.vip {
  color: #a25e22;
}

.vip-back {
  background: #af6e3e;
}

.clr_676767 {
  color: #676767;
}

.clr_777777 {
  color: #777777;
}

.clr_F55538 {
  color: #F55538;
}

.clr_868686 {
  color: #868686;
}

.clr_F0D9C3 {
  color: #F0D9C3;
}

.clr_5D3C09 {
  color: #5D3C09;
}

.clr_F5E7CC {
  color: #F5E7CC;
}

.clr_FFE9E4 {
  color: #FFE9E4;
}

.clr_8F8A7D {
  color: #8F8A7D;
}

.clr_F55538 {
  color: #F55538;
}

.clr_999 {
  color: #999;
}

.clr_191919 {
  color: #191919;
}

.clr_666 {
  color: #666;
}

.clr_333 {
  color: #333;
}

body {
  margin: 0 !important;
}

.height-100 {
  height: 100%;
}

.back-icon {
  width: 7px;
  height: 11px;
  transform: rotate(180deg);
}

.fixed {
  position: fixed;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.margin-bottom-2 {
  margin-bottom: 2px;
}

.margin-bottom-23 {
  margin-bottom: 23px;
}

.margin-bottom-4 {
  margin-bottom: 4px;
}

.margin-bottom-5 {
  margin-bottom: 5px;
}

.margin-bottom-6 {
  margin-bottom: 6px;
}

.margin-bottom-8 {
  margin-bottom: 8px;
}

.margin-bottom-10 {
  margin-bottom: 10px;
}

.margin-bottom-12 {
  margin-bottom: 12px;
}

.margin-bottom-14 {
  margin-bottom: 14px;
}

.margin-bottom-16 {
  margin-bottom: 16px;
}

.margin-bottom-18 {
  margin-bottom: 18px;
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.margin-bottom-22 {
  margin-bottom: 22px;
}

.margin-bottom-24 {
  margin-bottom: 24px;
}

.margin-bottom-25 {
  margin-bottom: 25px;
}

.margin-bottom-26 {
  margin-bottom: 26px;
}

.margin-bottom-28 {
  margin-bottom: 28px;
}

.margin-bottom-30 {
  margin-bottom: 30px;
}

.margin-bottom-32 {
  margin-bottom: 32px;
}

.margin-bottom-38 {
  margin-bottom: 38px;
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.margin-bottom-80 {
  margin-bottom: 80px;
}

.margin-top-42 {
  margin-top: 42px;
}

.margin-top-2 {
  margin-top: 2px;
}

.margin-top-34 {
  margin-top: 34px;
}

.margin-top-3 {
  margin-top: 3px;
}

.margin-top-30 {
  margin-top: 30px;
}

.margin-top-4 {
  margin-top: 4px;
}

.margin-top-5 {
  margin-top: 5px;
}

.margin-top-6 {
  margin-top: 6px;
}

.margin-top-7 {
  margin-top: 7px;
}

.margin-top-8 {
  margin-top: 8px;
}

.margin-top-9 {
  margin-top: 9px;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-top-12 {
  margin-top: 12px;
}

.margin-top-13 {
  margin-top: 13px;
}

.margin-top-14 {
  margin-top: 14px;
}

.margin-top-15 {
  margin-top: 15px;
}

.margin-top-16 {
  margin-top: 16px;
}

.margin-top-17 {
  margin-top: 17px;
}

.margin-top-18 {
  margin-top: 18px;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-22 {
  margin-top: 22px;
}

.margin-top-23 {
  margin-top: 23px;
}

.margin-top-24 {
  margin-top: 24px;
}

.margin-top-32 {
  margin-top: 32px;
}

.margin-top-36 {
  margin-top: 36px;
}

.margin-top-45 {
  margin-top: 45px;
}

.margin-left-2 {
  margin-left: 2px;
}

.margin-left-3 {
  margin-left: 3px;
}

.margin-left-4 {
  margin-left: 4px;
}

.margin-left-5 {
  margin-left: 5px;
}

.margin-left-6 {
  margin-left: 6px;
}

.margin-left-7 {
  margin-left: 7px;
}

.margin-left-8 {
  margin-left: 8px;
}

.margin-left-10 {
  margin-left: 10px;
}

.margin-left-12 {
  margin-left: 12px;
}

.margin-left-13 {
  margin-left: 13px;
}

.margin-left-14 {
  margin-left: 14px;
}

.margin-left-16 {
  margin-left: 16px;
}

.margin-left-18 {
  margin-left: 18px;
}

.margin-left-20 {
  margin-left: 20px;
}

.margin-left-22 {
  margin-left: 22px;
}

.margin-left-24 {
  margin-left: 24px;
}

.margin-left-26 {
  margin-left: 26px;
}

.margin-left-32 {
  margin-left: 32px;
}

.margin-right-2 {
  margin-right: 2px;
}

.margin-right-3 {
  margin-right: 3px;
}

.margin-right-4 {
  margin-right: 4px;
}

.margin-right-5 {
  margin-right: 5px;
}

.margin-right-6 {
  margin-right: 6px;
}

.margin-right-7 {
  margin-right: 7px;
}

.margin-right-8 {
  margin-right: 8px;
}

.margin-right-10 {
  margin-right: 10px;
}

.margin-right-12 {
  margin-right: 12px;
}

.margin-right-13 {
  margin-right: 13px;
}

.margin-right-14 {
  margin-right: 14px;
}

.margin-right-16 {
  margin-right: 16px;
}

.margin-right-18 {
  margin-right: 18px;
}

.margin-right-19 {
  margin-right: 19px;
}

.margin-right-20 {
  margin-right: 20px;
}

.margin-right-24 {
  margin-right: 24px;
}
.margin-right-32 {
  margin-right: 32px;
}

.platform-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 4px;
}

.empty-top-min {
  margin-top: 56px;
  padding-bottom: 24px;
}

.empty-top-large {
  margin-top: 160px;
}

.empty-pic {
  width: 100%;
  height: 160px;
  font-size: 0;
  margin-bottom: 12px;
}

.common-btn {
  padding: 8px 16px;
  border-radius: 20px;
}

.border-radius-10 {
  border-radius: 10px 10px 10px 10px;
}

.rebate-box {
  background: #F55538;
  color: #fff;
}
.vip-rebate-box {
  background: #FFD44B;
  color: #000000;
}

.vip-box {
  background: #F55538;
  color: #fff;
}

.comment-box {
  border: 1px solid #25c68a;
  color: #25c68a;
}

.common-box{
  border-radius: 5px;
  height: 17px;
  box-sizing: border-box;
  font-size: 11px;
  font-weight: 500;
  line-height: 11px;
  padding: 2px 5px;
  display: flex;
  align-items: center;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.width-0 {
  width: 0;
}

.width-100 {
  width: 100%;
}

.ellipses {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ell-two {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.padding-20 {
  padding: 20px;
}

.padding-bottom-10 {
  padding-bottom: 10px;
}

.padding-bottom-15 {
  padding-bottom: 15px;
}

.padding-bottom-16 {
  padding-bottom: 16px;
}

.padding-bottom-120 {
  padding-bottom: 120px;
}

.shake-ani {
  -webkit-animation: animate 0.7s linear infinite;
  animation: animate 0.7s linear infinite;
}

@-webkit-keyframes animate {
  0%,
  to {
    transform: scale(1);
  }

  25% {
    transform: scale(1.02);
  }

  50% {
    transform: scale(1.05);
  }

  75% {
    transform: scale(1.02);
  }
}

@keyframes animate {
  0%,
  to {
    transform: scale(1);
  }

  25% {
    transform: scale(1.02);
  }

  50% {
    transform: scale(1.05);
  }

  75% {
    transform: scale(1.02);
  }
}

.width-stretch {
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
}
</style>
